export default __webpack_public_path__ + "static/media/GridIcon.5f530188.svg";